import React, { useEffect, useRef, useState } from 'react';
import {
  Image,
  Popover,
  Menu,
  Modal,
  Alert,
  Spin,
  Message,
  Divider,
} from '@arco-design/web-react';
import { IconClose, IconLeft, IconRight } from '@arco-design/web-react/icon';
import logout_icon from '@/assets/layout/logout.png';
import ClientTabs from '@/mobx/modules/tabStore';
import { useHistory } from 'react-router-dom';
import { observer } from 'mobx-react-lite';

import zoom_max from '@/assets/login/zoom_max.png';
import zoom_min from '@/assets/login/zoom_min.png';
import minimize from '@/assets/login/minimize.png';
import close from '@/assets/login/close.png';
import update from '@/assets/layout/update.png';
import _ from 'lodash';
import { Tabs } from '@arco-design/web-react';
import { getAppVersion } from '@/api/modules/app';
import Cookies from 'js-cookie';
import { clientUpdateStore, userStore } from '@/mobx';
import ClientUpdate from '@/mobx/modules/clientUpdate';
import './index.less';

const MenuItem = Menu.Item;
const TabPane = Tabs.TabPane;

const WebviewAuth = () => {
  const history = useHistory();
  const [isMaximized, setIsMaximized] = useState(false);
  const [visible, setVisible] = useState(false);
  const [versionLoading, setVersionLoading] = useState<boolean>(false);
  const [version, setVersion] = useState<string>('');
  const [userInfo, setUserInfo] = React.useState({
    avatar_color: '',
    nickname: '',
    avatar: '',
  });
  const [avatar, setAvatar] = React.useState('');
  const isContinuousScrollingRef = useRef(false);
  const [currentDirection, setCurrentDirection] = useState(0); // 当前滚动方向
  const [isAtLeft, setIsAtLeft] = useState(true); // 是否已经滚动到最左边
  const [isAtRight, setIsAtRight] = useState(false); // 是否已经滚动到最右边
  const contentWrapperRef = useRef(null);
  const scrollAmount = 160; // 每次滚动的距离
  const continuousScrollSpeed = 10; // 连续滚动时的速度
  const scrollTimeoutRef = useRef(null); // 用于存储定时器

  const handleToMain = () => {
    history.push('/');
  };
  const handleMinimize = () => {
    window.electron.ipcRenderer.windowControl.minimize();
  };

  const handleMaximize = () => {
    window.electron.ipcRenderer.windowControl.maximize();
  };

  const handleClose = () => {
    window.electron.ipcRenderer.windowControl.close();
  };
  // 连续滚动（长按）
  const continuousScroll = (direction) => {
    if (isContinuousScrollingRef.current && contentWrapperRef.current) {
      contentWrapperRef.current.scrollLeft += direction * continuousScrollSpeed;
      requestAnimationFrame(() => continuousScroll(direction));
    }
  };
  const handleMouseDown = (direction) => {
    setCurrentDirection(direction);

    // 设置定时器，200ms 后认为是长按
    scrollTimeoutRef.current = setTimeout(() => {
      // setIsContinuousScrolling(true);
      isContinuousScrollingRef.current = true;
      continuousScroll(direction);
    }, 200);
  };
  // 离散滚动（短按）
  const discreteScroll = (direction) => {
    if (contentWrapperRef.current) {
      contentWrapperRef.current.scrollBy({
        left: direction * scrollAmount,
        behavior: 'smooth',
      });
    }
  };

  const handleMouseUpOrLeave = () => {
    if (scrollTimeoutRef.current) {
      clearTimeout(scrollTimeoutRef.current);
      scrollTimeoutRef.current = null;
      // 如果长按未触发，则执行一次离散滚动
      if (!isContinuousScrollingRef.current) {
        discreteScroll(currentDirection);
      }
    }
    isContinuousScrollingRef.current = false;
  };
  // 更新按钮的显隐
  const updateButtonVisibility = () => {
    const contentWrapper = contentWrapperRef.current;
    console.log('====================================');
    console.log(contentWrapper.scrollWidth);
    console.log(contentWrapper.clientWidth);

    console.log('====================================');
    const atLeft = contentWrapper.scrollLeft === 0;
    const atRight =
      contentWrapper.scrollLeft ===
      contentWrapper.scrollWidth - contentWrapper.clientWidth;

    setIsAtLeft(atLeft);
    setIsAtRight(atRight);
  };
  const checkAppleSystem = () => {
    const userAgent = navigator.userAgent || navigator.vendor;
    // 使用类型断言来绕过类型检查
    if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) {
      return true;
    } else if (/Macintosh|MacIntel|MacPPC|Mac68K/.test(userAgent)) {
      return true;
    } else {
      return false;
    }
  };

  // 监听滚动事件
  useEffect(() => {
    const contentWrapper = contentWrapperRef.current;
    if (!contentWrapper) return;
    const handleScroll = () => {
      updateButtonVisibility();
    };
    contentWrapper.addEventListener('scroll', handleScroll);
    // 初始化时检查按钮显示状态
    updateButtonVisibility();
    // 清理监听器
    return () => {
      contentWrapper.removeEventListener('scroll', handleScroll);
    };
  }, [ClientTabs.tabsActiveKey]);

  const [logo, setLogo] = useState('');
  useEffect(() => {
    const obj = JSON.parse(localStorage.getItem('AppStore') || '{}');
    setLogo(obj?.config?.web?.app?.collapse_logo);
  }, []);

  const handleOnClickMenu = (e) => {
    localStorage.removeItem('Token');
    window.location.href = `/login?next=${
      window.location.pathname + window.location.search
    }`;
  };
  const handleGetVersion = async () => {
    if (window.electron.ipcRenderer.getVersion) {
      const version = await window.electron.ipcRenderer.getVersion();
      ClientUpdate.setVersion(version);
    }
  };
  const handlegetAppVersion = async () => {
    setVersionLoading(true);
    const isLatestVersion = await clientUpdateStore.checkIsLatestVersion();
    if (isLatestVersion) {
      Message.success('当前版本是最新版本');
    } else {
      clientUpdateStore.update();
    }
  };
  const teamMenu = () => {
    return (
      <>
        <p className="menu-user"> {userStore.userInfo?.nickname}</p>
        <Divider
          style={{
            margin: '6px 0',
            borderBottomStyle: 'dashed',
            borderColor: '#eee',
          }}
        />
        <Menu
          onClickMenuItem={async (e) => {
            switch (e) {
              case '1':
                ClientTabs.setIsShowDoc(true);
                break;
              case '2':
                // sessionStorage.removeItem('next_update');
                // Cookies.remove('ClientSkip');
                // handlegetAppVersion();
                setVersionLoading(true);
                const isLatest = await clientUpdateStore.checkIsLatestVersion();
                setVersionLoading(false);
                console.log('isLatest========>', isLatest);
                if (isLatest) {
                  Message.success('已是最新版本');
                  return;
                }
                clientUpdateStore.update();
                break;
              case '3':
                localStorage.removeItem('Token');
                window.location.href = `/login?next=${
                  window.location.pathname + window.location.search
                }`;
                if (window.electron) {
                  window.electron.ipcRenderer.send('logout');
                }
                break;
              default:
                break;
            }
            if (e !== '2') {
              setVisible(false);
            }
          }}
        >
          {/* <MenuItem key="1">
            <Image
              style={{
                marginRight: '10px',
                marginBottom: '4px',
              }}
              src={use}
              width={14}
              preview={false}
            />
            使用教程
          </MenuItem>
          */}
          {window.electron && (
            <MenuItem key="2">
              <div style={{ display: 'flex', alignItems: 'center' }}>
                {versionLoading ? (
                  <>
                    <Spin />
                    <p>版本检查中</p>
                  </>
                ) : (
                  <>
                    <Image
                      style={{
                        marginRight: '5px',
                      }}
                      src={update}
                      width={14}
                      preview={false}
                    />
                    <p>版本更新</p>
                  </>
                )}
              </div>
            </MenuItem>
          )}
          <MenuItem key="3">
            <Image
              style={{
                marginLeft: -2,
                marginRight: '5px',
                marginBottom: '4px',
              }}
              src={logout_icon}
              width={14}
              preview={false}
            />
            退出登录
          </MenuItem>
        </Menu>
      </>
    );
  };
  const getClientVersion = async () => {
    const res = await window?.electron?.ipcRenderer?.getVersion();
    setVersion(res);
  };
  useEffect(() => {
    // 监听主进程传来的窗口状态变化
    if (window && window.electron) {
      window.electron.ipcRenderer.windowStateChanged((state) => {
        setIsMaximized(state);
      });

      handleGetVersion();
      getClientVersion();
    }

    // 清理事件监听器
    return () => {
      if (window && window.electron) {
        window.electron.ipcRenderer.removeListener(
          'window-state-changed',
          () => {
            //
          }
        );
        window.electron.ipcRenderer.removeListener('window-video-auth', () => {
          //
        });
      }
    };
  }, []);

  return (
    <div className="webview-auth">
      <Modal
        style={{
          overflow: 'hidden',
          width: 800,
          height: 600,
        }}
        visible={ClientTabs.isShowDoc}
        footer={null}
        closeIcon={<IconClose fontSize={25} />}
        onCancel={() => ClientTabs.setIsShowDoc(false)}
      >
        <iframe
          src={ClientTabs.configUrl}
          style={{
            width: 800,
            height: 660,
            display: 'block',
            border: 'none',
            position: 'absolute',
            top: -63,
            left: 0,
          }}
        />
      </Modal>

      <Tabs
        activeTab={`${ClientTabs.tabsActiveKey}`}
        renderTabHeader={(props: any) => {
          const { activeTab, paneChildren } = props;
          return (
            <div
              style={{
                display: 'flex',
                position: 'relative',
              }}
            >
              <div className="clent-tabs">
                <div ref={contentWrapperRef} className="account-wrapper">
                  {paneChildren.map((item, index) => {
                    const v = ClientTabs.tabs.find((v) => v.key == item.key);
                    return (
                      <div
                        className={`clent-item ${
                          item.key == activeTab ? 'clent-active' : ''
                        }
               ${
                 ClientTabs.tabs[
                   ClientTabs.tabs.findIndex((v) => v.key == activeTab) - 1
                 ]?.key == item.key
                   ? 'clent-active-prev'
                   : ''
               }
             ${
               ClientTabs.tabs[
                 ClientTabs.tabs.findIndex((v) => v.key == activeTab) + 1
               ]?.key == item.key
                 ? 'clent-active-next'
                 : ''
             }`}
                        onClick={() => {
                          console.log('tab click===>', item.key);
                          if (item.key == 0) {
                            console.log('点击首页');
                            history.push('/matrix');
                            ClientTabs.setActivePath(0);
                            return;
                          }
                          ClientTabs.setActivePath(item.key);
                        }}
                        style={{
                          position: index == 0 ? 'absolute' : 'unset',
                          zIndex: 9,
                          marginLeft: index == 1 ? 153 : 0,
                        }}
                        key={index}
                      >
                        {v?.icon ? (
                          <img src={v.icon} width={20} alt="" />
                        ) : (
                          <></>
                        )}
                        <p
                          style={{ paddingLeft: index === 0 ? 6 : 0 }}
                          className="clent-text"
                        >
                          {item.props.title}
                        </p>
                        <div className="clent-close-icon">
                          <IconClose
                            fontSize={16}
                            style={{
                              marginRight: 9,
                              display: index === 0 ? 'none' : 'block',
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              ClientTabs.removeTab(item.key);
                            }}
                          />
                        </div>
                      </div>
                    );
                  })}
                </div>
                <div
                  className={`clent-scroll-left ${isAtLeft ? 'hidden' : ''}`}
                  onMouseDown={() => handleMouseDown(-1)}
                  onMouseUp={handleMouseUpOrLeave}
                  onMouseLeave={handleMouseUpOrLeave}
                >
                  <IconLeft />
                </div>
              </div>
              <div
                className={`clent-scroll-right ${isAtRight ? 'hidden' : ''}`}
                onMouseDown={() => handleMouseDown(1)}
                onMouseUp={handleMouseUpOrLeave}
                onMouseLeave={handleMouseUpOrLeave}
              >
                <IconRight />
              </div>
              <div
                className={`residue-space`}
                style={{
                  borderRadius:
                    ClientTabs.tabsActiveKey ===
                      ClientTabs.tabs[ClientTabs.tabs.length - 1].key &&
                    isAtRight
                      ? '0 0 0 15px'
                      : 0,
                }}
              ></div>
              <div className="clent-user">
                <Popover
                  popupVisible={visible}
                  onVisibleChange={() => {
                    setVisible(!visible);
                  }}
                  trigger={'hover'}
                  content={
                    <div className="user-tool">
                      <div>{teamMenu()}</div>
                    </div>
                  }
                >
                  <div
                    className="user-avatar"
                    style={{
                      background: userStore.userInfo?.avatar
                        ? ''
                        : userStore.userInfo?.avatar_color,
                    }}
                  >
                    {userStore.userInfo?.avatar ? (
                      <img
                        style={{
                          borderRadius: '50%',
                          width: 30,
                          objectFit: 'cover',
                          objectPosition: 'top',
                        }}
                        src={userStore.userInfo?.avatar}
                        alt=""
                      />
                    ) : (
                      userStore.userInfo?.nickname && (
                        <div className="clent-text">
                          {userStore.userInfo?.nickname.slice(-2)}
                        </div>
                      )
                    )}
                    {/* <div
                          className="clent-live"
                          style={{
                            background: ClientTabs.isLive
                              ? '#00B42A'
                              : '#cccccc',
                          }}
                        ></div> */}
                  </div>
                </Popover>
              </div>

              <div
                className="clent-tool"
                style={{ display: checkAppleSystem() ? 'none' : 'flex' }}
              >
                <div onClick={handleMinimize}>
                  <img src={minimize} alt="" />
                </div>
                <div onClick={handleMaximize}>
                  <img src={isMaximized ? zoom_min : zoom_max} alt="" />
                </div>
                <div onClick={handleClose}>
                  <img src={close} alt="" />
                </div>
              </div>
              {checkAppleSystem() ? (
                <div
                  style={{
                    width: 20,
                    background: '#F3F4F7',
                    height: 46,
                  }}
                ></div>
              ) : (
                <></>
              )}
            </div>
          );
        }}
      >
        {ClientTabs.tabs.map((item, index) => (
          <TabPane
            key={item.key}
            title={item.title}
            style={{
              height: '100%',
            }}
          >
            {item.title === '微信公众号' ? (
              <Alert
                type="error"
                content="登录若出现“二维码加载失败”，点击刷新无效，可以尝试点击“使用账号登录，在切换至二维码登录”"
                closable
                style={{ position: 'absolute', top: 60 }}
              />
            ) : null}
            {item.content ? (
              <div style={{ display: 'flex', height: 'calc(100vh - 60px)' }}>
                <div
                  className="iframe-content"
                  style={{
                    width: '100%',
                    height: '100%',
                  }}
                >
                  {item.content ? (
                    <div
                      style={{
                        width: '100%',
                        height: '100%',
                      }}
                      dangerouslySetInnerHTML={{ __html: item.content }}
                    />
                  ) : null}
                </div>
              </div>
            ) : null}
          </TabPane>
        ))}
      </Tabs>
    </div>
  );
};
export default observer(WebviewAuth);
